export type WaTemplateCategory = 'UTILITY' | 'MARKETING';
export type WaTemplateLanguage = 'pt_BR' | 'en_US' | 'es';
export type WaTemplateMediaType = 'none' | 'image' | 'video' | 'document';
export type WaTemplateButtonType = 'QUICK_REPLY' | 'URL' | 'PHONE_NUMBER';
export type WaTemplateStatus = 'APPROVED' | 'PENDING' | 'REJECTED';

export interface WaTemplateButton {
  id: string;
  type: WaTemplateButtonType;
  text: string;
  url?: string;
  phoneNumber?: string;
}

export interface WaTemplate {
  id: string;
  name: string;
  category: WaTemplateCategory;
  language: WaTemplateLanguage;
  mediaType: WaTemplateMediaType;
  mediaUrl?: string;
  headerText?: string;
  body: string;
  footer?: string;
  buttons: WaTemplateButton[];
  status: WaTemplateStatus;
  createdAt: string;
}

export const ROLT_VARIABLES = [
  { label: 'Nome do contato', value: '{{contact_name}}', placeholder: 'Joao' },
  { label: 'Telefone do contato', value: '{{contact_phone}}', placeholder: '+55 11 99999-0000' },
  { label: 'Email do contato', value: '{{contact_email}}', placeholder: 'joao@email.com' },
  { label: 'Nome da empresa', value: '{{company_name}}', placeholder: 'Minha Empresa' },
] as const;

export const LANGUAGE_OPTIONS: { value: WaTemplateLanguage; label: string }[] = [
  { value: 'pt_BR', label: 'Portugues (BR)' },
  { value: 'en_US', label: 'English (US)' },
  { value: 'es', label: 'Espanol' },
];

export const MOCK_TEMPLATES: WaTemplate[] = [
  {
    id: '1',
    name: 'pedido_confirmado',
    category: 'UTILITY',
    language: 'pt_BR',
    mediaType: 'none',
    body: 'Ola {1}! Seu pedido #{2} foi confirmado e esta sendo preparado. Previsao de entrega: {3}.',
    footer: 'Rolt - Sua plataforma de comunicacao',
    buttons: [
      { id: 'b1', type: 'URL', text: 'Rastrear Pedido', url: 'https://meusite.com/rastreio/{2}' },
    ],
    status: 'APPROVED',
    createdAt: '2026-02-10T10:00:00Z',
  },
  {
    id: '2',
    name: 'boas_vindas_cliente',
    category: 'MARKETING',
    language: 'pt_BR',
    mediaType: 'image',
    mediaUrl: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=400',
    body: 'Ola {1}! Bem-vindo(a) a {2}. Estamos felizes em te-lo conosco! Aproveite 10% de desconto na sua primeira compra com o cupom BEMVINDO10.',
    footer: 'Responda SAIR para nao receber mais mensagens',
    buttons: [
      { id: 'b2', type: 'QUICK_REPLY', text: 'Ver ofertas' },
      { id: 'b3', type: 'QUICK_REPLY', text: 'Falar com atendente' },
    ],
    status: 'APPROVED',
    createdAt: '2026-02-08T14:30:00Z',
  },
  {
    id: '3',
    name: 'lembrete_pagamento',
    category: 'UTILITY',
    language: 'pt_BR',
    mediaType: 'none',
    body: 'Ola {1}, lembramos que sua fatura no valor de R$ {2} vence em {3}. Evite juros e pague em dia!',
    buttons: [
      { id: 'b4', type: 'URL', text: 'Pagar agora', url: 'https://meusite.com/pagar' },
      { id: 'b5', type: 'PHONE_NUMBER', text: 'Ligar para suporte', phoneNumber: '+551199999000' },
    ],
    status: 'PENDING',
    createdAt: '2026-02-15T09:00:00Z',
  },
  {
    id: '4',
    name: 'promo_black_friday',
    category: 'MARKETING',
    language: 'pt_BR',
    mediaType: 'video',
    body: '{1}, a Black Friday chegou! Descontos de ate 70% em todos os produtos. Corra porque as ofertas sao por tempo limitado!',
    footer: 'Valido ate 30/11. Responda SAIR para cancelar',
    buttons: [
      { id: 'b6', type: 'URL', text: 'Ver ofertas', url: 'https://meusite.com/black-friday' },
    ],
    status: 'REJECTED',
    createdAt: '2026-02-01T08:00:00Z',
  },
];

export const getStatusColor = (status: WaTemplateStatus) => {
  switch (status) {
    case 'APPROVED':
      return {
        bg: 'bg-[#ECFDF5] dark:bg-green-500/15',
        text: 'text-[#16A34A] dark:text-[#22C55E]',
        label: 'Aprovado',
      };
    case 'PENDING':
      return {
        bg: 'bg-[#FFFBEB] dark:bg-amber-500/15',
        text: 'text-[#D97706] dark:text-[#F59E0B]',
        label: 'Pendente',
      };
    case 'REJECTED':
      return {
        bg: 'bg-[#FEF2F2] dark:bg-red-500/15',
        text: 'text-[#DC2626] dark:text-[#F87171]',
        label: 'Rejeitado',
      };
  }
};

export const getCategoryLabel = (category: WaTemplateCategory) => {
  return category === 'UTILITY' ? 'Utilidade' : 'Marketing';
};

export const getMediaTypeLabel = (type: WaTemplateMediaType) => {
  switch (type) {
    case 'none': return 'Nenhuma';
    case 'image': return 'Imagem';
    case 'video': return 'Video';
    case 'document': return 'Documento';
  }
};
